var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"navigation"},[_c('button',{staticClass:"navigation-prev",attrs:{"type":"button"},on:{"click":function($event){return _vm.slidePrev()}}},[_c('span')]),_vm._v(" "),_c('button',{staticClass:"navigation-next",attrs:{"type":"button"},on:{"click":function($event){return _vm.slideNext()}}},[_c('span')])])
}
var staticRenderFns = []

export { render, staticRenderFns }